<template>
  <div>
    <v-btn
      icon
      @click="toggleNotificationsMenu"
    >
      <v-badge
        color="error"
        overlap
        dot
        bordered
        :value="unreadNotifications"
      >
        <v-icon :color="$route.name == 'Home' ? 'primary' : 'white'">
          mdi-bell-outline
        </v-icon>
      </v-badge>
    </v-btn>

    <FullscreenDialog
      title=""
      v-model="notificationsMenu"
    >
      <template slot="content">
        <v-container class="px-5 pt-7">
          <v-row>
            <v-col>
              <h1 class="mb-7">
                {{ $t("notifications.title") }}
              </h1>
              <v-sheet
                outlined
                rounded
                elevation="1"
                v-if="filteredNotifications.length > 0"
              >
                <v-list
                  two-line
                  class="py-0"
                >
                  <template v-for="(item, index) in filteredNotifications">
                    <v-list-item
                      v-if="item.notificationType == 'OperationalStatus'"
                      :key="`${item.notificationId}-status`"
                    >
                      <template>
                        <div
                          class="school-logo align-self-start my-4"
                          :style="
                            `border-color: ${getSchoolColour(item.schoolId)}`
                          "
                        >
                          <v-img
                            v-if="item.schoolId != 'global'"
                            width="20"
                            height="20"
                            class="flex-grow-0 flex-shrink-0"
                            :src="schoolLogo(item.schoolId)"
                          />
                          <v-img
                            v-else
                            width="20"
                            height="20"
                            class="flex-grow-0 flex-shrink-0"
                            src="/NSWGov_Logo-40.png"
                          />
                        </div>
                        <div class="align-self-start flex-grow-1 my-4 ml-3">
                          <div
                            class="notification-title mb-2"
                            style="font-size: 1.125rem"
                          >
                            {{ item.title }}
                          </div>
                          <span class="text-body-2">
                            {{ formatDate(item.timestamp) }}
                          </span>
                        </div>
                      </template>
                    </v-list-item>
                    <v-list-item
                      v-else
                      :key="item.notificationId"
                      @click="toggle(item)"
                      :class="`notification-card ${findRead(item)}`"
                    >
                      <template>
                        <div
                          class="school-logo align-self-start my-4"
                          :style="
                            `border-color: ${getSchoolColour(item.schoolId)}`
                          "
                        >
                          <v-img
                            v-if="item.schoolId != 'global'"
                            width="20"
                            height="20"
                            class="flex-grow-0 flex-shrink-0"
                            :src="schoolLogo(item.schoolId)"
                          />
                          <v-img
                            v-else
                            width="20"
                            height="20"
                            class="flex-grow-0 flex-shrink-0"
                            src="/NSWGov_Logo-40.png"
                          />
                        </div>
                        <div class="align-self-start flex-grow-1 my-4 ml-3">
                          <div
                            class="notification-title mb-2"
                            style="font-size: 1.125rem"
                          >
                            {{ item.title }}
                          </div>
                          <span class="text-body-2">
                            {{ formatDate(item.timestamp) }}
                          </span>
                        </div>
                        <v-list-item-action class="align-self-start mt-6">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-action>
                      </template>
                    </v-list-item>

                    <v-divider
                      v-if="index < filteredNotifications.length - 1"
                      :key="index"
                    />
                  </template>
                </v-list>
              </v-sheet>
              <div
                v-else
                class="text-center mt-15"
              >
                <v-icon
                  size="100"
                  color="#CBEDFD"
                >
                  mdi-check-circle-outline
                </v-icon>
                <div
                  class="text-h6 mx-auto"
                  style="width: 75%"
                >
                  {{ $t("notifications.emptyInbox") }}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </FullscreenDialog>
  </div>
</template>
<script>
import { AppIcon, FullscreenDialog } from "@nswdoe/doe-ui-core";
import Notifications from "./Notifications";
import { mapGetters } from "vuex";

const AppBarNotifications = {
  name: "AppBarNotifications",
  computed: {
    ...mapGetters([
      "readArticles",
      "readEvents",
      "readNewsletters",
      "filteredNotifications"
    ]),
    unreadNotifications() {
      let notifications = this.filteredNotifications
        .filter(
          notification => notification.notificationType !== "OperationalStatus"
        )
        .map(notification => notification.notificationId);

      const completeRead = this.readArticles.concat(
        this.readEvents,
        this.readNewsletters
      );

      return !notifications.every(item => completeRead.includes(item));
    },
    appBuild() {
      return this.getCookie("appbuild");
    }
  },
  components: {
    AppIcon,
    FullscreenDialog,
    Notifications
  },
  props: {
    mySchools: {
      type: Array,
      default: function() {
        return [];
      }
    },
    appFilters: {
      type: Array,
      default: function() {
        return [];
      }
    },
    title: String
  },
  methods: {
    schoolName(id) {
      if (id != "global") {
        return this.mySchools.find(school => school.schoolId == id)?.details
          .name;
      }

      return "NSW Department of Education";
    },
    schoolCode(id) {
      if (id != "global") {
        return this.mySchools.find(school => school.schoolId == id)?.schoolCode;
      }

      return "NSW Department of Education";
    },
    schoolLogo(id) {
      if (id != "global") {
        return this.mySchools.find(school => school.schoolId == id)?.details
          .logo;
      }

      return "my-nsw-gov";
    },
    getSchoolColour(schoolId) {
      if (schoolId != "global") {
        return this.mySchools.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )?.details.colour;
      }
      return "#264189";
    },
    findRead(item) {
      switch (item.notificationType) {
        case "NewsArticle":
          return this.$store.getters["readArticles"].find(
            a => a === item.notificationId
          )
            ? "read"
            : null;
        case "Event":
          return this.$store.getters["readEvents"].find(
            a => a === item.notificationId
          )
            ? "read"
            : null;
        case "Newsletter":
          return this.$store.getters["readNewsletters"].find(
            a => a === item.notificationId
          )
            ? "read"
            : null;
      }
    },
    toggle(item) {
      switch (item.notificationType) {
        case "NewsArticle":
          this.analytics("notification_inbox", {
            item_category: "notification",
            notification_type: "open_news_articles",
            school_code: this.schoolCode(item.schoolId),
            school_name: this.schoolName(item.schoolId),
            content_title: item.title,
            content_id: item.notificationId
          });
          this.$router.push(`/news/${encodeURIComponent(item.notificationId)}`);
          break;
        case "Event":
          this.analytics("notifications_inbox", {
            item_category: "notification",
            notification_type: "open_calendar_notification",
            school_code: this.schoolCode(item.schoolId),
            school_name: this.schoolName(item.schoolId),
            content_title: item.title,
            content_id: item.notificationId
          });
          this.$router.push(
            `/events/${encodeURIComponent(item.notificationId)}`
          );
          break;
        case "Newsletter":
          this.analytics("notifications_inbox", {
            item_category: "notification",
            notification_type: "open_newsletter",
            school_code: this.schoolCode(item.schoolId),
            school_name: this.schoolName(item.schoolId),
            content_title: item.title,
            content_id: item.notificationId
          });
          this.openNewsletter(item);
          break;
      }
    },
    openNewsletter(newsletter) {
      const { notificationId } = newsletter;
      this.$store.dispatch("setNewsletterRead", notificationId);
      this.$store
        .dispatch("getIndividualNewsletter", notificationId)
        .then(response => {
          if (response.type === "link") {
            //eslint-disable-next-line
            NativeJS.debugLog(
              `open external link (${response.link}) ${typeof response.link}`
            );
            //eslint-disable-next-line
            NativeJS.externalLink(response.link);
          } else if (response.type === "file") {
            //eslint-disable-next-line
            NativeJS.debugLog(`open pdf (${response.filePath})`);
            //eslint-disable-next-line
            NativeJS.openPDF(response.filePath);
          }
        });

      // if (link != null) {
      //   //eslint-disable-next-line
      //   NativeJS.debugLog(`open external link (${link}) ${typeof link}`)
      //   //eslint-disable-next-line
      //   NativeJS.externalLink(link)
      // }
    },
    formatDate(date) {
      let formattedDate = new Date(date).toLocaleDateString(this.getLocale(), {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
      let formattedTime = new Date(date).toLocaleTimeString(this.getLocale(), {
        timeStyle: "short"
      });
      if (this.getToday(date)) {
        return `${this.$t("notifications.today")} ${formattedTime}`;
      } else if (this.getYesterday(date)) {
        return `${this.$t("notifications.yesterday")} ${formattedTime}`;
      } else {
        return formattedDate + " " + formattedTime;
      }
    },
    getToday(dateString) {
      return new Date(dateString).toLocaleDateString("en-us") ===
        new Date().toLocaleDateString("en-us")
        ? true
        : false;
    },
    getYesterday(dateString) {
      let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return new Date(dateString).toLocaleDateString("en-us") ===
        yesterday.toLocaleDateString("en-us")
        ? true
        : false;
    },
    toggleNotificationsMenu() {
      this.notificationsMenu = true;
      this.analytics("notification_inbox", {
        action: "button_click",
        item_category: "notification"
      });
    }
  },
  data() {
    return {
      filter: this.appFilters.map(school => {
        return {
          id: school.id,
          value: school.value
        };
      }),
      notificationsMenu: false
    };
  },
  watch: {
    title() {
      this.filter = this.mySchools.map((school, i) => {
        let schoolId = school.schoolId;
        return {
          id: schoolId,
          value: this.appFilters[i] ? this.appFilters[i].value : false
        };
      });
      console.log("app Filter changes");
    }
  }
};
export default AppBarNotifications;
</script>
<style lang="scss" scoped>
.school-logo {
  padding: 7px;
  border: 2px solid;
  border-radius: 100px;
}
.notification-card {
  background-color: rgb(203, 237, 253, 0.2);
  .notification-title {
    font-weight: 500;
  }
  &.read {
    background-color: transparent;
    .notification-title {
      font-weight: 400;
    }
  }
}
</style>
